import React from 'react';
import { Link } from 'react-router-dom';

import styles from './marketing.module.css';
import { SEO } from '../components/SEO.jsx';

import heroImage from '../pictures/Singapore Business District.avif';
import founderImage from '../pictures/Blockchain Blackboard.avif';
import picPatentSingapore from '../pictures/Patent Singapore.avif';
import picPatentUS1 from '../pictures/US patent-1.avif';
import picPatentUS2 from '../pictures/US patent-2.avif';
import picPatentIndia from '../pictures/Patent India.avif';
import picPatentEU from '../pictures/Patent EU.avif';
import picPatentJapan from '../pictures/Patent Japan.avif';

const patentImages = [
  picPatentSingapore,
  picPatentUS1,
  picPatentUS2,
  picPatentIndia,
  picPatentEU,
  picPatentJapan,
];

export const Story = () => (
  <main className={styles.page}>
    <SEO
      title="The Back-Step Blockchain Story"
      description="The founder story, Singapore origin, and international patent foundation behind Back-Step Blockchain and Blockchain Systems Pte. Ltd."
      path="/story"
    />

    <section className={styles.hero}>
      <img className={styles.heroImage} src={heroImage} alt="Singapore business district" />
      <div className={styles.heroOverlay} />
      <div className={styles.heroContent}>
        <p className={styles.kicker}>Story</p>
        <h1 className={styles.heroTitle}>Invented in Singapore. Built around a global trust opportunity.</h1>
        <p className={styles.heroText}>
          Back-Step Blockchain began with a simple question: can blockchain trust become faster, more practical,
          and easier to use in real products and services?
        </p>
        <div className={styles.actions}>
          <Link className={styles.primaryAction} to="/products">See products</Link>
          <Link className={styles.secondaryAction} to="/investors">Investor view</Link>
        </div>
      </div>
    </section>

    <section className={styles.section}>
      <div className={styles.split}>
        <div className={styles.splitCopy}>
          <p className={styles.kicker}>Founder perspective</p>
          <h2>From cryptography experience to a new commercial trust layer.</h2>
          <p>
            Georg Krause founded Blockchain Systems Pte. Ltd. to bring Back-Step Blockchain from invention
            into products. The work combines cryptography, hardware, software, and a practical view of how
            companies explain trust to customers.
          </p>
          <p>
            The goal is not to sell complexity. The goal is to make authenticity, ownership, and tamper evidence
            easier to use in markets that already need stronger proof.
          </p>
        </div>
        <div className={styles.photoPanel}>
          <img src={founderImage} alt="Blockchain concept work" />
        </div>
      </div>
    </section>

    <section className={styles.sectionAlt}>
      <div className={styles.sectionInner}>
        <div className={styles.sectionHeader}>
          <p className={styles.kicker}>Patent foundation</p>
          <h2>A protected invention with international reach.</h2>
          <p>
            Patents have been granted in key markets including Singapore, China, Japan, the United States,
            South Korea, Israel, the United Kingdom, India, and Europe under the Unitary Patent system.
          </p>
        </div>
        <div className={styles.patentGrid}>
          {patentImages.map((image, index) => (
            <img key={image} src={image} alt={`Back-Step Blockchain patent document ${index + 1}`} />
          ))}
        </div>
      </div>
    </section>
  </main>
);
